import { i18n } from '@lingui/core';
import React from 'react';
import I18nProvider from './lingui/I18nProvider';

export default function wrapPageElement({ element, props }) {
  // console.log(props);
  return (
    <I18nProvider i18n={i18n} {...props.pageContext}>
      {element}
    </I18nProvider>
  );
}
